<h3 mat-dialog-title="" translate="" [translateParams]="{value: message}">Are you sure you want to complete ...?</h3>
<mat-dialog-content>
  <span translate="">This action cannot be undone.</span>
</mat-dialog-content>
<mat-dialog-actions class="flex justify-start content-center items-center flex-row gap-[1rem]">
  <button mat-flat-button="" color="warn" [mat-dialog-close]="true"><span translate="">Yes</span></button>
  <button mat-stroked-button="" [mat-dialog-close]="false" cdkFocusInitial=""><span translate="">No</span></button>
</mat-dialog-actions>